import React, { Component } from "react";
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import CompareGreaterRegion from "../Common/CompareGreaterRegion";
import CompareMarketsList from "../Desktop/CompareMarketsList";
import RentCycleConstants from "../../constants/RentCycleConstants";
import '../../css/MarketCompare.scss';

export class MarketCompare extends Component {

  onClose = (e) => {
    this.props.onClose && this.props.onClose(e);
  };

  showRightPanel = (e) => {
    this.props.showRightPanel && this.props.showRightPanel(e);
  };

  hideAddCompareButton = (e) => {
    this.props.hideAddCompareButton && this.props.hideAddCompareButton(e);
  }
  render() {

    if (!this.props.show) {
      return null;
    }

    return (
      <div>
        <Modal isOpen={this.props.show} className="compare-modal-dialog" wrapClassName="gortcustomclass">
          <ModalHeader toggle={this.onClose} className="compare-modalHeader">
            <p className="add-comparison-market-label-desktop">{RentCycleConstants.ADD_COMPARISON_MARKET}</p>
            {/* <p className="Select-the-market-desktop">{RentCycleConstants.ADD_COMPARISON_SUB_TEXT}</p> */}
          </ModalHeader>
          <ModalBody style={{padding: "0px"}}>
            <Row className="compare-modalButtonGroup" style={{ justifyContent: 'left'}}>
              <CompareGreaterRegion></CompareGreaterRegion>
            </Row>
            <Row>
              <CompareMarketsList markets={this.props.comparemarketslist} onClose={this.onClose} showRightPanel={this.showRightPanel} hideAddCompareButton={this.hideAddCompareButton}></CompareMarketsList>
            </Row>
          </ModalBody>
          <ModalFooter className="compare-modalFooter">
            {/* <Button id="compare-cancel-button" className="btn-cancel compare-cancel-button" onClick={this.onClose}>{RentCycleConstants.CANCEL}</Button>  */}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    comparemarketslist: state.comparemarketslist
  };
};

export default connect(
  mapStateToProps
)(MarketCompare);
